module.exports = __webpack_public_path__ + "img/UT0407.a33dfd7a.png";